import { render, staticRenderFns } from "./adminEmpresas.vue?vue&type=template&id=3d447bad&scoped=true"
import script from "./adminEmpresas.vue?vue&type=script&lang=js"
export * from "./adminEmpresas.vue?vue&type=script&lang=js"
import style0 from "./adminEmpresas.vue?vue&type=style&index=0&id=3d447bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d447bad",
  null
  
)

export default component.exports